import { render } from "./ExamClaimBulkExportOffcanvas.vue?vue&type=template&id=8ec2a8ca&scoped=true"
import script from "./ExamClaimBulkExportOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExamClaimBulkExportOffcanvas.vue?vue&type=script&lang=js"

import "./ExamClaimBulkExportOffcanvas.vue?vue&type=style&index=0&id=8ec2a8ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec2a8ca"]])

export default __exports__